import { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';

import { type CategoryNode } from '../../category-tree';

type SubjectCategoryError = {
  subject?: string;
  subSubject?: string;
};

export const useValidateSubjectCategory = () => {
  const [errors, setErrors] = useState<SubjectCategoryError>({});
  const { t } = useTranslation(['build']);

  const validate = useCallback(
    ({
      selectedSubjectNode,
      subjectNodeList,
    }: {
      selectedSubjectNode?: CategoryNode;
      subjectNodeList?: CategoryNode[];
    }) => {
      if (!!subjectNodeList?.length && !selectedSubjectNode) {
        setErrors({ subject: t('build:schoolInfo.requiredField') });
        return false;
      }
      // 유효하면 에러 클리어
      setErrors({});
      return true;
    },
    [t],
  );

  const clearError = useCallback(() => {
    setErrors({});
  }, []);

  return {
    errors,
    validate,
    clearError,
  };
};
